import { Card, Text, Image, Float, Box, Blockquote } from "@chakra-ui/react"
import { Link } from "@tanstack/react-router"
import { PublicationPreviewProps } from "../../api/landingpage"


const PublicationPreview = ({publication} : PublicationPreviewProps) => {
  return (
    <Link to="/$slug" params={{ slug: publication.classic_id }}>
      <Card.Root maxW={{xl: "lg", "2xl": "2xs"}} w="full" data-testid="publication_card" h="full">
        <Card.Header pos="relative" p={0} maxH={{ sm: "16em", xl: "14em" }}>
          {publication.lead_image ? (
            <Image
              src={publication.lead_image.path.replace(/-(LG)\./, "-MD.")}
              alt={publication.lead_image.file_name}
              h={{ base: "16em", xl: "14em" }}
              borderTopRadius="md"
              objectFit="cover"
              objectPosition={`${publication.lead_image.focal_point ? publication.lead_image.focal_point[0] : 50}% ${publication.lead_image.focal_point ? publication.lead_image.focal_point[1] : 50}%`}
            />
          ) : (
              <Box borderTopRadius="md" h={{ base: "16em", xl: "14em" }} bgColor="main"></Box>
          )}

          <Float
            display="block"
            pos="absolute"
            top={3}
            left={-3}
            translate="none"
            backgroundColor="mainOpacity"
            color="white"
            px={5}
            py={0.5}
            w="90%"
            minH="24px"
            boxShadow="rgba(0, 0, 0, 0.35) 0px 5px 15px"
          >
            <Text hyphens="auto" data-testid="publication_card_subtitle" fontWeight="bold">
                {publication.subtitle && publication.subtitle != "" ? publication.subtitle : publication.fk_categories.at(0)?.name}
            </Text>
          </Float>

          <Box
            position="absolute"
            bottom={0}
            left={0}
            right={0}
            height="50%"
            bg="linear-gradient(
              0deg,
              rgba(0, 0, 0, 0.7) 0%,
              rgba(0, 0, 0, 0.55) 40%,
              rgba(0, 0, 0, 0.25) 75%,
              rgba(0, 0, 0, 0) 100%
            );"
            pointerEvents="none"
          />

          <Float
            display="block"
            pos="absolute"
            bottom={3}
            left={2}
            translate="none"
            color="secondary"
            h="fit-content"
            insetBlockStart="auto"
          >
            <Blockquote.Root borderInlineStartColor="main">
              <Blockquote.Content
                hyphens="auto"
                data-testid="publication_card_title"
                fontWeight="bold"
              >
                {publication.title}
              </Blockquote.Content>
            </Blockquote.Root>
          </Float>
        </Card.Header>

        {publication.lead ? (
          <Box>
            <Card.Body
              gap="2"
              w="full"
              h="full"
              p={3}
            >
                <Card.Description
                  lineClamp={5}
                  hyphens="auto"
                  data-testid="publication_card_desc"
                  color="black"
                >
                  {publication.lead}
                </Card.Description>
            </Card.Body>
          </Box>
        ) : (
          <Box>
            <Card.Body
              gap="2"
              w="full"
              h="full"
              p={3}
            >
              <Card.Description
                lineClamp={5}
                hyphens="auto"
                data-testid="publication_card_desc"
                color="black"
                dangerouslySetInnerHTML={{ __html: publication.content }}
              />
            </Card.Body>
          </Box>
        )}
      </Card.Root>
    </Link>
  )
}

export default PublicationPreview
